import { useTranslate } from '@festina-life/ui/hooks'
import type { JSX } from 'react'

import { useVariantAction } from '../../hooks/useVariantAction'
import { useHook } from '../../lenteHooks'
import { CommandModalButton } from '../commandActions/CommandModalButton'
import type { ActionButtonProps } from '../commandActions/types'
import { UpdatePartnershipCommandDataForm } from './UpdatePartnershipCommandDataForm'

/**
 * Updating a partner concerns the event where a partner is updated for a person, so that the relationship update between a participant and the partner is added, and the partner is updated with a name. In the portal it can be carried out by applying a command.
 *
 * @links
 * More information about this topic can be found via the links below. You may benefit from reading these before reading about the same topic in the portal.
 *
 * - [LegalEntity commands](@root/legalentity/legalentity-server/doc/solution/commands/LegalEntityCommands.md)
 * - @api legalentity-shared/UpdatePartnershipCommandData, Update partnership command@
 *
 */

export const UpdatePartnershipCommand = (
  props: ActionButtonProps,
): JSX.Element => {
  const translate = useTranslate()

  const { tenantId, ownerId } = useHook('routing.general.useEntityParams')()
  const actions = useHook('mutators.crm.useUpdatePartnershipCommandActions')({
    tenantId,
    personId: ownerId,
    ...props,
  })
  const submit = useVariantAction({
    ...props,
    actions,
  })

  return (
    <CommandModalButton
      actionId="legalEntity.UpdatePartnershipCommandData"
      title={translate('updatePartnerButton.buttonUpdate')}
      commandDataForm={UpdatePartnershipCommandDataForm}
      {...props}
      submit={submit}
    />
  )
}
